import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { MasterDataSeriveService } from './Services/master-data-serive.service';
import { UserserviceService } from './Services/userservice.service';
import { environment } from './environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationGuard implements CanActivate {
  formMasters: string[] = ['Production Screen', 'Top Performer Proud'];

  constructor(private userService :UserserviceService,private router: Router, private masterService: MasterDataSeriveService) { }

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    
    let user = localStorage.getItem('user');

    // The SSO cookie is visible to every app on the shared domain. External
    // accounts (consignors, donors) belong to their own portals and must never
    // open a session here, regardless of what localStorage already holds.
    const accessToken = this.userService.getAuthToken();
    if (accessToken && !this.userService.isInternalUser(accessToken)) {
      this.userService.denyExternalUser();
      return false;
    }

    if(user){
        let requiredPermission = route.data['permission'];

        if(requiredPermission=='General'){
          let user = this.masterService.getUserDetailsFromStorage();
          if(user && user.userId > 0){
            return true
          }else{
            // AB#14151: don't bounce to the root route here either — same
            // destructive LoginComponent wipe as the async permission-fetch
            // path below. Deny this activation instead of forcing a full
            // session reset when this is likely just a transient read.
            return false;
          }
        }
            
        return this.userService.getUserRolesandPerm()
        .then((permissions) => {
          const hasPermission = permissions.some((permission) => permission.name === requiredPermission);

          if (hasPermission) {
            return true;
          } else {
            this.router.navigate(['']); // Redirect if no permission
            return false;
          }
        })
        .catch((error) => {
          console.error('Error fetching permissions:', error);
          // AB#14151: don't bounce to the root route here — LoginComponent
          // unconditionally clears localStorage/sessionStorage on load, which
          // was turning a transient permission-fetch failure (network blip,
          // slow response) into a full, jarring session reset for actively
          // producing users even though their auth cookies were still valid.
          // Just deny this activation; the user's current screen/state stays
          // intact and the next navigation attempt gets a fresh try.
          return false;
        });
   }
   else{
    const returnUrl = encodeURIComponent(window.location.href);
    window.location.replace(`${environment.companyWebBaseUrl}/login?redirectTo=${returnUrl}`);
    return false; // Redirect to login if user is not authenticated   
   }

  }
}
